import Vue from 'vue';
import Vuex from 'vuex';
import moment from 'moment';
import relatorios from './modules/relatorios';
import regrasUsuario from './modules/regrasUsuario';
import vendedores from './modules/vendedores';
import empresas from './modules/empresas';
import revendedores from './modules/revendedores';
import { Dashboard } from './modules/dashboard/index';

Vue.use(Vuex);
const format = () => {
  let local = Utils.getLocal('v360.typeDateFilter');
  return local == 'month' ? 'MM/YYYY' : 'DD/MM/YYYY';
};

export default new Vuex.Store({
  modules: {
    relatorios: {
      namespaced: true,
      ...relatorios
    },
    regrasUsuario: {
      namespaced: true,
      ...regrasUsuario
    },
    dashboard: {
      namespaced: true,
      ...Dashboard
    },
    vendedores: {
      namespaced: true,
      ...vendedores
    },
    empresas: {
      namespaced: true,
      ...empresas
    },
    revendedores: {
      namespaced: true,
      ...revendedores
    }
  },
  state: {
    User: {},
    msgCount: {
      messages: 2
    },
    metaId: '',
    loadingMetasModal: false,
    metasVendedoresFilter: {},
    vendedoresMetas: [],
    calendarModel: [],
    siderCollapsed: false,
    dateOptions: {
      shortcuts: [
        {
          title: 'Hoje',
          value() {
            return {
              start: moment().format(format()),
              end: moment().format(format())
            };
          }
        },
        {
          title: 'Ontem',
          value() {
            return {
              start: moment().subtract(1, 'days').format(format()),
              end: moment().subtract(1, 'days').format(format())
            };
          }
        },
        {
          title: 'Últimos 7 dias',
          value(incluirHoje) {
            return {
              start: moment().subtract(incluirHoje ? 6 : 7, 'days').format(format()),
              end: moment().subtract(incluirHoje ? 0 : 1, 'days').format(format())
            };
          }
        },
        {
          title: 'Mês Atual',
          value(incluirHoje) {
            return {
              start: moment().startOf('month').format(format()),
              end: moment().subtract(incluirHoje ? 0 : 1, 'days').format(format())
            };
          }
        },
        {
          title: 'Mês passado',
          value() {
            return {
              start: moment().subtract(1, 'month').startOf('month').format(format()),
              end: moment().subtract(1, 'month').endOf('month').format(format())
            };
          }
        },
        {
          title: 'Acumulado ano',
          value() {
            return {
              start: moment().startOf('year').format(format()),
              end: moment().format(format())
            };
          }
        }
      ],
      shortcutsFiltroLocal: [
        {
          title: 'Ontem',
          value() {
            return {
              start: moment().subtract(1, 'days').format(format()),
              end: moment().subtract(1, 'days').format(format())
            };
          }
        },
        {
          title: 'Últimos 7 dias',
          value(incluirHoje) {
            return {
              start: moment().subtract(incluirHoje ? 6 : 7, 'days').format(format()),
              end: moment().subtract(incluirHoje ? 0 : 1, 'days').format(format())
            };
          }
        },
        {
          title: 'Mês Atual',
          value(incluirHoje) {
            return {
              start: moment().startOf('month').format(format()),
              end: moment().subtract(incluirHoje ? 0 : 1, 'days').format(format())
            };
          }
        },
        {
          title: 'Mês passado',
          value() {
            return {
              start: moment().subtract(1, 'month').startOf('month').format(format()),
              end: moment().subtract(1, 'month').endOf('month').format(format())
            };
          }
        },
        {
          title: 'Acumulado ano',
          value() {
            return {
              start: moment().startOf('year').format(format()),
              end: moment().format(format())
            };
          }
        },
        {
          title: 'Hoje',
          value() {
            return {
              start: moment().format(format()),
              end: moment().format(format())
            };
          }
        },
        {
          title: 'Últimos 15 dias',
          value(incluirHoje) {
            return {
              start: moment().subtract(incluirHoje ? 14 : 15, 'days').format(format()),
              end: moment().subtract(incluirHoje ? 0 : 1, 'days').format(format())
            };
          }
        },
        {
          title: 'Últimos 28 dias',
          value(incluirHoje) {
            return {
              start: moment().subtract(incluirHoje ? 27 : 28, 'days').format(format()),
              end: moment().subtract(incluirHoje ? 0 : 1, 'days').format(format())
            };
          }
        },
        {
          title: 'Últimos 30 dias',
          value(incluirHoje) {
            return {
              start: moment().subtract(incluirHoje ? 29 : 30, 'days').format(format()),
              end: moment().subtract(incluirHoje ? 0 : 1, 'days').format(format())
            };
          }
        },
        {
          title: 'Esta semana (Começa no domingo)',
          value(incluirHoje) {
            return {
              start: moment().startOf('week').format(format()),
              end: moment().subtract(incluirHoje ? 0 : 1, 'days').format(format())
            };
          }
        },
        {
          title: 'Esta semana (Começa no segunda-feira)',
          value(incluirHoje) {
            return {
              start: moment().startOf('isoWeek').format(format()),
              end: moment().subtract(incluirHoje ? 0 : 1, 'days').format(format())
            };
          }
        },
        {
          title: 'Semana passada (Começa na segunda-feira)',
          value() {
            return {
              start: moment().subtract(2, 'isoWeek').format(format()),
              end: moment().subtract(1, 'isoWeek').format(format())
            };
          }
        },
        {
          title: 'Semana passada (Começa no domingo)',
          value() {
            return {
              start: moment().subtract(2, 'Week').format(format()),
              end: moment().subtract(1, 'Week').format(format())
            };
          }
        },
        {
          title: 'Trimestre passado',
          value() {
            return {
              start: moment().subtract(6, 'month').endOf('month').format(format()),
              end: moment().subtract(3, 'month').format(format())
            };
          }
        },
        {
          title: 'Este trimestre, até agora',
          value(incluirHoje) {
            return {
              start: moment()
                .subtract(3, 'month')
                .subtract(incluirHoje ? 0 : 1, 'days')
                .format(format()),
              end: moment().format(format())
            };
          }
        },
        {
          title: 'Este ano',
          value() {
            return {
              start: moment().startOf('year').format(format()),
              end: moment().endOf('year').format(format())
            };
          }
        },
        {
          title: 'Ano passado',
          value() {
            return {
              start: moment().subtract(1, 'year').startOf('year').format(format()),
              end: moment().subtract(1, 'year').endOf('year').format(format())
            };
          }
        }

      ]
    },
    switchPeriodo: {
      5: 'Acumulado ano',
      4: 'Mês passado',
      3: 'Mês Atual',
      2: 'Ultimos 7 dias',
      1: 'Ontem',
      0: 'Hoje'
    },
    intervalo: ''
  },
  mutations: {
    updatevendedoresMetas(state, data) {
      state.vendedoresMetas = data;
    },
    updateCalendarModel(state, data) {
      state.calendarModel = data;
    },
    clearVendedoresMetas(state) {
      state.vendedoresMetas = [];
    },
    updateMetasVendedoresFilter(state, data) {
      state.metasVendedoresFilter = { ...data };
    },
    updateAccount(state, data) {
      state.User = data;
    },
    updateSiderCollapse(state, isShow) {
      setTimeout(() => {
        G.trigger('page_resize');
      }, 600);
      state.siderCollapsed = isShow;
    },
    updateMsgCount(state, data) {
      state.msgCount = data;
    },
    updateLoadingMetasModal(state, payload) {
      state.loadingMetasModal = payload;
    },
    updateMetaId(state, payload) {
      state.metaId = payload;
    },
    updateIntervalo(state, payload) {
      state.intervalo = payload;
    }
  },
  actions: {
    updateAccount(context, data) {
      context.commit('updateAccount', data);
    },
    updateLoadingMetasModal({ commit }, payload) {
      commit('updateLoadingMetasModal', payload);
    },
    updateSiderCollapse(context, data) {
      context.commit('updateSiderCollapse', data);
    },
    updateMsgCount(context, data) {
      context.commit('updateMsgCount', data);
    }
  },
  getters: {
    format: state => {
      return format();
    },
    account: state => {
      return state.User;
    },
    exibirLoadingMetasVendedor: state => {
      return state.vendedoresMetas.length > 30;
    },
    siderCollapsed: state => {
      return state.siderCollapsed;
    },
    msgCount: state => {
      return state.msgCount;
    },
    metasVendedorFilter: state => {
      return state.metasVendedorFilter;
    },
    mesAtual: state => {
      const dias = state.calendarModel.dates;
      if (!Array.isArray(dias)) return [];
      return state.calendarModel.dates.filter(date => date.mesAtual);
    },
    getPermission: state => (...actions) => {
      const storage = JSON.parse(localStorage.getItem('v360.permissao'));
      if (storage) {
        return actions.some(item => storage.includes(item));
      } else {
        return false;
      }
    }
  }
});
